import { clone, startCase } from 'lodash';

import actionClassMapping from './ActionClassMapping.json';
import actionStatementMapping from './ActionStatementMapping';

export function getActionViewData(log) {
  return clone(actionClassMapping[log.action]);
}

export function getActionStatement(log) {
  const mapping =  actionStatementMapping[log.typeName]?.[log.userAction];

  if (mapping?.statement) {
    const statement = mapping.statement;

    const isLinkedWithSecondaryObject = mapping.linkedWithAnotherItem;

    if (isLinkedWithSecondaryObject) {
      try {
        const diffKey = Object.keys(log.diff)[0];

        const secondaryObjectName = mapping?.secondaryObjectMappingWithDiffProperty?.[diffKey];

        if (secondaryObjectName) {
          return statement.replace('[{userName}]', log.userName).replace('[{objectName}]', log.objectName).replace('[{secondaryObjectName}]', secondaryObjectName);
        } else {
          return getDefaultStatement(log);
        }
      } catch (error) {
        return getDefaultStatement(log);
      }
    }

    return statement.replace('[{userName}]', log.userName).replace('[{objectName}]', log.objectName);
  }

  return getDefaultStatement(log);
}

export function getDefaultStatement(log) {
  const viewData = getActionViewData(log);
  return (log.userName || '') + ' ' + viewData.actionText  + ' ' + startCase(log.typeName) + ' ' + '<strong>' + (log.objectName || log.objectId) + '</strong>';
}